import { motion } from "framer-motion";

export const AnimatedSmartMatch = ({
    className,
    starColor = "white",
}: {
    className?: string;
    starColor?: string;
}) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <motion.path
                d="M2.04351 4.60472L2.73905 4.86123C3.30217 5.06889 3.74607 5.51276 3.95369 6.07584L4.21023 6.77143C4.21988 6.79757 4.24481 6.81494 4.27268 6.81494C4.30056 6.81494 4.32549 6.79757 4.33513 6.77143L4.59168 6.07588C4.79934 5.51276 5.24324 5.06889 5.80631 4.86123L6.50189 4.60472C6.52804 4.59508 6.54541 4.57015 6.54541 4.54227C6.54541 4.5144 6.52804 4.48947 6.50189 4.47982L5.80627 4.22323C5.2432 4.01557 4.79934 3.57171 4.59168 3.00863L4.33513 2.313C4.32549 2.28685 4.30056 2.26949 4.27268 2.26949C4.24481 2.26949 4.21988 2.28685 4.21023 2.313L3.95369 3.00863C3.74603 3.57171 3.30217 4.01561 2.73909 4.22323L2.04347 4.47982C2.01732 4.48947 1.99996 4.5144 1.99996 4.54227C1.99996 4.57015 2.01736 4.59508 2.04351 4.60472Z"
                fill={starColor}
                animate={{
                    scale: [1, 1.2, 1],
                    opacity: [0.7, 1, 0.7],
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 0.5,
                }}
            />
            <motion.path
                d="M18.0105 5.75404L18.3443 5.87716C18.6146 5.97684 18.8277 6.18989 18.9274 6.46017L19.0505 6.79405C19.0551 6.80661 19.0671 6.81494 19.0805 6.81494C19.0939 6.81494 19.1058 6.80661 19.1105 6.79405L19.2336 6.46019C19.3333 6.18989 19.5463 5.97684 19.8166 5.87716L20.1505 5.75404C20.1631 5.74941 20.1714 5.73744 20.1714 5.72406C20.1714 5.71068 20.1631 5.69871 20.1505 5.69408L19.8166 5.57092C19.5463 5.47124 19.3333 5.25819 19.2336 4.98791L19.1105 4.65401C19.1058 4.64146 19.0939 4.63312 19.0805 4.63312C19.0671 4.63312 19.0551 4.64146 19.0505 4.65401L18.9274 4.98791C18.8277 5.25819 18.6146 5.47126 18.3444 5.57092L18.0105 5.69408C17.9979 5.69871 17.9896 5.71068 17.9896 5.72406C17.9896 5.73744 17.9979 5.74941 18.0105 5.75404Z"
                fill={starColor}
                animate={{
                    scale: [1, 1.3, 1],
                    opacity: [0.7, 1, 0.7],
                }}
                transition={{
                    duration: 2.5,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
            />
            <motion.path
                d="M18.0105 18.6984L18.3443 18.8215C18.6146 18.9212 18.8277 19.1342 18.9274 19.4045L19.0505 19.7384C19.0551 19.7509 19.0671 19.7593 19.0805 19.7593C19.0939 19.7593 19.1058 19.7509 19.1105 19.7384L19.2336 19.4045C19.3333 19.1342 19.5463 18.9212 19.8166 18.8215L20.1505 18.6984C20.1631 18.6937 20.1714 18.6818 20.1714 18.6684C20.1714 18.655 20.1631 18.643 20.1505 18.6384L19.8166 18.5153C19.5463 18.4156 19.3333 18.2025 19.2336 17.9322L19.1105 17.5983C19.1058 17.5858 19.0939 17.5775 19.0805 17.5775C19.0671 17.5775 19.0551 17.5858 19.0505 17.5983L18.9274 17.9322C18.8277 18.2025 18.6146 18.4156 18.3444 18.5153L18.0105 18.6384C17.9979 18.643 17.9896 18.655 17.9896 18.6684C17.9896 18.6818 17.9979 18.6937 18.0105 18.6984Z"
                fill={starColor}
                animate={{
                    scale: [1, 1.4, 1],
                    opacity: [0.7, 1, 0.7],
                }}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 0.8,
                }}
            />
            <g clipPath="url(#clip0_18170_61246)">
                <path
                    d="M10.0001 11.9999L11.3335 13.3332L14.0001 10.6666M6.5668 9.74657C6.46949 9.30825 6.48443 8.85246 6.61023 8.42146C6.73604 7.99046 6.96863 7.5982 7.28644 7.28105C7.60425 6.9639 7.997 6.73213 8.42827 6.60723C8.85953 6.48233 9.31535 6.46835 9.75346 6.56657C9.9946 6.18944 10.3268 5.87907 10.7194 5.66409C11.1121 5.44911 11.5525 5.33643 12.0001 5.33643C12.4478 5.33643 12.8882 5.44911 13.2808 5.66409C13.6735 5.87907 14.0057 6.18944 14.2468 6.56657C14.6856 6.46792 15.1422 6.48184 15.5741 6.60704C16.0061 6.73225 16.3994 6.96466 16.7174 7.28267C17.0354 7.60068 17.2678 7.99395 17.393 8.4259C17.5182 8.85786 17.5321 9.31446 17.4335 9.75324C17.8106 9.99437 18.121 10.3266 18.3359 10.7192C18.5509 11.1118 18.6636 11.5523 18.6636 11.9999C18.6636 12.4475 18.5509 12.888 18.3359 13.2806C18.121 13.6732 17.8106 14.0054 17.4335 14.2466C17.5317 14.6847 17.5177 15.1405 17.3928 15.5718C17.2679 16.003 17.0361 16.3958 16.719 16.7136C16.4018 17.0314 16.0096 17.264 15.5786 17.3898C15.1476 17.5156 14.6918 17.5305 14.2535 17.4332C14.0126 17.8118 13.6802 18.1235 13.2869 18.3394C12.8936 18.5554 12.4521 18.6686 12.0035 18.6686C11.5548 18.6686 11.1133 18.5554 10.72 18.3394C10.3267 18.1235 9.99429 17.8118 9.75346 17.4332C9.31535 17.5315 8.85953 17.5175 8.42827 17.3926C7.997 17.2677 7.60425 17.0359 7.28644 16.7188C6.96863 16.4016 6.73604 16.0093 6.61023 15.5783C6.48443 15.1473 6.46949 14.6916 6.5668 14.2532C6.18677 14.0127 5.87374 13.68 5.65683 13.286C5.43992 12.8921 5.32617 12.4496 5.32617 11.9999C5.32617 11.5502 5.43992 11.1077 5.65683 10.7138C5.87374 10.3198 6.18677 9.98707 6.5668 9.74657Z"
                    stroke="white"
                    strokeWidth="1.83"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_18170_61246">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(4 4)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
